import { render, staticRenderFns } from "./usdt-stake-dialog.vue?vue&type=template&id=4b28b26d&scoped=true&"
import script from "./usdt-stake-dialog.vue?vue&type=script&lang=ts&"
export * from "./usdt-stake-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./usdt-stake-dialog.vue?vue&type=style&index=0&id=4b28b26d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28b26d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VIcon,VImg,VSheet,VTextField})
